<template>
  <div class="container-fluid pt-0">
    <CreateGroupRecord
      v-if="createGroupRecordModal"
      :show="createGroupRecordModal"
      v-on:closeGroupRecordModal="createGroupRecordModal = false"
    />
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <div class="row">
      <div class="col-5">
        <h4 class="p-b-20">{{$t("rec")}}</h4>
      </div>
      <div class="col-7">
        <div class="d-flex align-items-center justify-content-end">
          <button
            @click="createGroupRecordModal = true"
            class="btn btn-primary"
          >
            {{$t("new_rec")}}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="mssg"
      align="center"
      class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
    >
      <p class="alert-close mb-0">
        {{ mssg }}
      </p>
    </div>
    <div
      v-else-if="Errormssg"
      align="center"
      class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
    >
      <p class="alert-close mb-0">
        {{ Errormssg }}
      </p>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="table-responsive">
              <div
                id="zero_config_wrapper"
                class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
              >
                <div class="row" style="height: 25rem; overflow: auto;">
                  <div class="col-sm-12">
                    <table id="order-listing" class="table table-hover display">
                      <thead>
                        <tr>
                          <th>{{$t("rec_name")}}</th>
                          <th>{{$t("start_time")}}</th>
                          <th>{{$t("end_time")}}</th>
                          <th>{{$t("created_on")}}</th>
                          <th>{{$t("actions")}}</th>
                        </tr>
                      </thead>
                      <tbody v-if="grouprecords.length > 0">
                        <tr
                          :key="index"
                          v-for="(record, index) in grouprecords"
                          class="user-row"
                        >
                          <td
                            @click.prevent="viewgroup(record._id)"
                            class="cursor-pointer"
                          >
                            {{ record.name }}
                          </td>
                          <td
                            @click.prevent="viewgroup(record._id)"
                            class="cursor-pointer"
                          >
                            <div v-if="record.start">
                              {{ getDate(record.start) }}
                            </div>
                            <div v-else>{{$t("waiting")}}</div>
                          </td>
                          <td
                            @click.prevent="viewgroup(record._id)"
                            class="cursor-pointer"
                          >
                            <div v-if="record.end">
                              {{ getDate(record.end) }}
                            </div>
                            <div v-else>{{$t("waiting")}}</div>
                          </td>
                          <td
                            @click.prevent="viewgroup(record._id)"
                            class="cursor-pointer"
                          >
                            {{ getDate(record.createdAt) }}
                          </td>
                          <td>
                            <div class="d-flex">
                              <div
                                :class="{ 'inactive-icon': record.start }"
                                class="mr-3 cursor-pointer"
                                @click="startrecord(record._id)"
                              >
                                <IconPlay />
                              </div>
                              <div
                                :class="{ 'inactive-icon': record.end || !record.start }"
                                class="cursor-pointer"
                                @click="endrecord(record._id)"
                              >
                                <IconStop />
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr align="center">
                          <td colspan="5">
                            <div class="col-md-6 col-lg-5 mx-auto">
                              <h3 class="mt-3">{{$t("no_rec")}}</h3>
                              <p class="mb-0">
                                {{$t("scd_rec")}}
                              </p>
                              <p>
                                {{$t("create_rec")}}
                              </p>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import vClickOutside from "v-click-outside";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import CreateGroupRecord from "../Modals/CreateGroupRecord";
import IconPlay from "../../components/Iconsvg/IconPlay";
import IconStop from "../../components/Iconsvg/IconStop";

export default {
  name: "GroupDevices",
  data() {
    return {
      isOpen: false,
      mssg: "",
      Errormssg: "",
      isLoading: true,
      fullPage: true,
      createGroupRecordModal: false,
      grouprecordsclone: [],
    };
  },
  mounted() {
    this.fetchGroupRecords({ id: this.$route.params.id })
      .then(() => {
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        if (error.response) {
          //console.log(error.response);
          this.$router.push("/404");
        }
      });
  },
  components: {
    Loading,
    CreateGroupRecord,
    IconStop,
    IconPlay,
  },
  computed: {
    ...mapGetters(["grouprecords"]),
  },
  methods: {
    ...mapActions(["fetchGroupRecords", "endGroupRecord", "startGroupRecord"]),
    viewgroup(id) {
      this.$router.push(`records/${id}`);
    },
    getDate(date) {
      return moment(date, "x", true).format("ddd, MMM Do YYYY, hh:mm a");
    },
    openModal() {
      this.isOpen = true;
    },
    endrecord(record_id) {
      this.isLoading = true;
      this.endGroupRecord({
        id: this.$route.params.id,
        recordId: record_id,
      })
        .then((res) => {
          if (res.data.status === "success") {
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
            this.fetchGroupRecords({
              id: this.$route.params.id,
            }).then(() => {
              this.mssg = "";
              this.isLoading = false;
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    startrecord(record_id) {
      this.isLoading = true;
      this.startGroupRecord({
        id: this.$route.params.id,
        recordId: record_id,
      })
        .then((res) => {
          if (res.data.status === "success") {
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
            this.fetchGroupRecords({
              id: this.$route.params.id,
            }).then(() => {
              this.mssg = "";
              this.isLoading = false;
            });
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
  },
};
</script>

<style>
.inactive-icon svg path{
  stroke: #213e7a;
}
</style>
<style scoped>
.inactive-icon {
  pointer-events: none;
}
td {
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
}
th.active {
  color: #fff;
}
</style>
<i18n>
{
	"en": {
		"actions": "Actions (Start/End Record)",
		"create_rec": "Create a record to get started",
		"created_on": "Created On",
		"end_time": "End Time",
		"new_rec": "New Record",
		"no_rec": "You have no records yet",
		"rec": "Records",
		"rec_name": "Record Name",
		"scd_rec": "Schedule and monitor your devices with records",
		"start_time": "Start Time",
		"waiting": "Waiting"
	},
	"es": {
		"actions": "Acciones (Iniciar / Finalizar registro)",
		"create_rec": "Crea un registro para empezar",
		"created_on": "Creado en",
		"end_time": "hora de finalización",
		"new_rec": "Nuevo record",
		"no_rec": "Aún no tienes registros",
		"rec": "archivos",
		"rec_name": "Nombre de Registro",
		"scd_rec": "Programe y monitoree sus dispositivos con registros",
		"start_time": "Hora de inicio",
		"waiting": "Esperando"
	},
	"fr": {
		"actions": "Actions (enregistrement de début/fin)",
		"create_rec": "Créer un enregistrement pour commencer",
		"created_on": "Créé sur",
		"end_time": "Heure de fin",
		"new_rec": "Nouvel enregistrement",
		"no_rec": "Vous n'avez pas encore d'enregistrements",
		"rec": "Enregistrements",
		"rec_name": "Nom de l'enregistrement",
		"scd_rec": "Planifiez et surveillez vos appareils avec des enregistrements",
		"start_time": "Heure de début",
		"waiting": "Attendre"
	},
	"sw": {
		"actions": "Vitendo (Anza/Mwisho Rekodi)",
		"create_rec": "Unda rekodi ili kuanza",
		"created_on": "Imeundwa Juu",
		"end_time": "Wakati wa mwisho",
		"new_rec": "Rekodi Mpya",
		"no_rec": "Bado huna rekodi",
		"rec": "Rekodi",
		"rec_name": "Jina la Rekodi",
		"scd_rec": "Ratibu na ufuatilie vifaa vyako na rekodi",
		"start_time": "Wakati wa kuanza",
		"waiting": "Kusubiri"
	}
}
</i18n>